var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 19H20V5H4V19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71178 10.1529L9 10.2904V10.6135V13.3865V13.7106L8.71178 13.8482L0.713555 17.6606L0.00100078 18L0 17.199V13.5608V13.2071L0.325253 13.0828L3.28355 11.9536L0.292227 10.5564L0 10.4209V10.0938V6.80102V6L0.713555 6.34038L8.71178 10.1529Z",
    fill: "#71CEF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8471 8.71178L13.7096 9H13.3865L10.6135 9H10.2894L10.1518 8.71178L6.33936 0.713555L6 0.00100078L6.80102 0L10.4392 0L10.7929 0L10.9172 0.325253L12.0464 3.28355L13.4436 0.292227L13.5791 0L13.9062 0L17.199 0L18 0L17.6596 0.713555L13.8471 8.71178Z",
    fill: "#71CEF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8471 15.2882L13.7096 15H13.3865L10.6135 15H10.2894L10.1518 15.2882L6.33936 23.2864L6 23.999L6.80102 24L10.4392 24H10.7929L10.9172 23.6747L12.0464 20.7164L13.4436 23.7078L13.5791 24H13.9062H17.199H18L17.6596 23.2864L13.8471 15.2882Z",
    fill: "#71CEF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2882 10.1529L15 10.2904V10.6135V13.3865V13.7106L15.2882 13.8482L23.2864 17.6606L23.999 18L24 17.199V13.5608V13.2071L23.6747 13.0828L20.7164 11.9536L23.7078 10.5564L24 10.4209V10.0938V6.80102V6L23.2864 6.34038L15.2882 10.1529Z",
    fill: "#71CEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.71d726385ab8dea21b6f39ca21569204.svg";
export { ForwardRef as ReactComponent };